import * as React from 'react'
import { Action, any, IOWidget, Pair } from 'widgets-for-react';
import { fromJSX } from '../../../../../utils';
import { CustomRouteParams } from '../../../../cms/router/type.gen';
import { emptyAppState, PublicSiteState } from '../../../../public_site.main.mod';
import { WordPressBlockImagesLoader } from '../../../../wordpress/rendering/image_utils.mod';
import { WordPressBlock_To_WidgetBlock } from '../../../../wordpress/wordpress_to_cms.gen';
import { notfound_page } from '../../../templates/error_page.mod';
import { loader } from '../../../templates/loader.mod';
import { page } from '../../../templates/page.mod';
import { CustomPagesState, PublicSiteCustomRoutes } from '../../types.mod';
import { CustomBlock_To_Widget } from '../../../CustomBlockToWidget'
import { HomeSplash } from '../components/HomeSplash';
import { PageTemplateComponent } from '../../../../cms/page/widget.gen';
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen';
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.mod';
import { CustomBlockData } from '../../../blocks/custom_blocks/types.mod';
import { ExtraImages } from '../../../utils/extra_images.mod';
import { PublicSite_CustomPageData } from '../../../application.mod';
import { TemplateState } from '../../../../cms/page/types.gen';


export let homeCurrentScroll: number = 0;
export let homeScrollDirection: string = '';
export let homeAnimFrameId: number = null;

function homeRequestAnimationFrame() {
  // Exit and restart the scrollHandling if there was no difference in scroll
  if (window.scrollY == homeCurrentScroll) {
    handleHomeScrollDesktop('init'); // Init the parallax once to show correct values on page load
    // handleHomeParallax('init'); // Init the parallax once to show correct values on page load
    handleMobileHomeParallax('init'); // Init the parallax once to show correct values on page load
    homeAnimFrameId = requestAnimationFrame(homeRequestAnimationFrame);
    return;
  }

  if (window.scrollY < homeCurrentScroll) {
    homeScrollDirection = 'up';
  } else {
    homeScrollDirection = 'down';
  }

  // ----- Scroll -----
  handleHomeScrollDesktop('runtime');
  // ----- end Scroll -----

  // ----- PARALLAX -----
  // handleHomeParallax('runtime');
  handleMobileHomeParallax('runtime');
  // ----- end PARALLAX -----

  homeCurrentScroll = window.scrollY;
  homeAnimFrameId = requestAnimationFrame(homeRequestAnimationFrame); // Restart the scrollHandling
  return;
}

function handleHomeScrollDesktop(type: 'init' | 'runtime') {
  if (window.innerWidth < 768) { return; }
  if (document.documentElement.classList.contains('splash--open')) { return; }

  const homeStoriesContainer: HTMLElement = document.querySelector('.home-theme__wrap');
  const homeStories: NodeListOf<HTMLElement> = document.querySelectorAll('.home-theme');
  const homeSpacers: NodeListOf<HTMLElement> = document.querySelectorAll('.portraits__spacer');

  if ((
    (homeStories == null || homeStoriesContainer == null || homeSpacers == null) ||
    (type == 'init' && homeStoriesContainer != null && homeStoriesContainer.classList.contains('init'))
  )) {
    return
  }

  homeStoriesContainer.setAttribute('data-direction', homeScrollDirection);

  if(homeStoriesContainer.getBoundingClientRect().top <= 0 && window.scrollY > (window.innerHeight / 2)) {
    homeStoriesContainer.classList.add('inview');
  } else {
    homeStoriesContainer.classList.remove('inview');
  }
  
  homeSpacers.forEach((v, k) => {
    let currentItem = document.querySelector(`.home-theme.${v.getAttribute('data-theme')}`);
    if (
      (k == 0 && v.getBoundingClientRect().top <= 0) ||
      (k != 0 && v.getBoundingClientRect().top <= (window.innerHeight / 2 - 100) && homeScrollDirection == 'down') ||
      (k != 0 && v.getBoundingClientRect().top <= ((window.innerHeight / 2) + 100) && homeScrollDirection == 'up')
    ) {
      v.classList.add('desk-active');
      currentItem.classList.add('desk-active');
    } else {
      v.classList.remove('desk-active');
      currentItem.classList.remove('desk-active');
    }

    if(k == 3 && v.getBoundingClientRect().top <= 0) {
      currentItem.classList.add('desk-sticky');
    } else {
      currentItem.classList.remove('desk-sticky');
    }
  });

  if (!homeStoriesContainer.classList.contains('init')) {
    homeStoriesContainer.classList.add('init');
  }
}

function handleMobileHomeParallax(type: 'init' | 'runtime') {
  if (document.documentElement.classList.contains('splash--open')) { return; }
  if (window.innerWidth >= 768) { return; }

  const homePortraitsContainer: HTMLElement = document.querySelector('.home-theme__wrap');
  const homePortraits: NodeListOf<HTMLElement> = document.querySelectorAll('.portraits--mobile');
  const homeStories: NodeListOf<HTMLElement> = document.querySelectorAll('.home-theme');

  if ((
    (homeStories == null || homePortraitsContainer == null) ||
    (type == 'init' && homePortraitsContainer != null && homePortraitsContainer.classList.contains('init--mobile'))
  )) {
    return
  }

  homePortraitsContainer.setAttribute('data-direction', homeScrollDirection);
  homePortraits.forEach((v, k) => v.style.transform = "translate3d(0, " + (homePortraitsContainer.getBoundingClientRect().top + (k * v.closest('.home-theme').clientHeight)) + "px, 0)");

  homeStories.forEach((v, k) => {
    const roundedTopPosition = (v.getBoundingClientRect().top < 1 && v.getBoundingClientRect().top > -1) ? Math.round(v.getBoundingClientRect().top) : v.getBoundingClientRect().top;
    if (roundedTopPosition <= 0) {
      v.classList.add('mob-active');
    } else {
      v.classList.remove('mob-active');
    }
  });

  const lastBlock:HTMLElement = document.querySelector('.home-theme:nth-child(4)');
  if(lastBlock != null) {
    if(lastBlock.getBoundingClientRect().bottom < window.innerHeight) {
      lastBlock.classList.add('mob-sticky');
    } else {
      lastBlock.classList.remove('mob-sticky');
    }
  }

  if (!homePortraitsContainer.classList.contains('init--mobile')) {
    homePortraitsContainer.classList.add('init--mobile');
  }
}

// function handleHomeParallax(type: 'init' | 'runtime') {
//   if (document.documentElement.classList.contains('splash--open')) { return; }
//   if (window.innerWidth < 768) { return; }
//   if (enableReducedMotion == true) { return; }

//   const homePortraitsContainer: HTMLElement = document.querySelector('.portraits--desktop');
//   const homePortraits: NodeListOf<HTMLElement> = document.querySelectorAll('.portraits--desktop .portrait--home');

//   if ((
//     (homePortraits == null || homePortraitsContainer == null) ||
//     (type == 'init' && homePortraitsContainer != null && homePortraitsContainer.classList.contains('init'))
//   )) {
//     return
//   }

//   homePortraits.forEach((v, k) => v.style.transform = "translate3d(0, -" + ((homeCurrentScroll / window.innerHeight) * parseInt(v.getAttribute('data-parallax'))) + "px, 0)");

//   if (!homePortraitsContainer.classList.contains('init')) {
//     homePortraitsContainer.classList.add('init');
//   }
// }

export let homeWidget = (r: Pair<CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>, CustomPagesState["Fc150YearsMainPage"]>): IOWidget<CustomPagesState['Fc150YearsMainPage'], Action<CustomPagesState['Fc150YearsMainPage']>> =>
  s0 => any<Action<CustomPagesState['Fc150YearsMainPage']>>()([
    fromJSX(setState => {

      let global_state: PublicSiteState = {
        ...emptyAppState(page),
        page: r.snd.state.page,
        Fc150YearsMainPage: s0
      }

      let template_props = {
        StandardBlockImagesLoader: WordPressBlockImagesLoader,
        StandardBlock_To_Widget: WordPressBlock_To_WidgetBlock,
        errorPage: notfound_page,
        loadingPage: loader,
        CustomBlock_To_Widget,
        CustomBlockImagesLoader: () => []
      }

      homeRequestAnimationFrame();

      return (
        <>
          {HomeSplash(s0).run(a => setState(s => a(s)))}

          {/**Additional styling can be found in renderer.mod.tsx The page will render differently when on the homepage */}
          {PageTemplateComponent<Block, CustomBlock, CustomBlockData, ExtraImages, PublicSite_CustomPageData, PublicSiteState>({
            pageDisplay: p => global_state.page.pagedisplay(p, global_state),
            Display: b => global_state.page.display(b),
            CustomBlock_To_Widget: template_props.CustomBlock_To_Widget,
            CustomBLockImagesLoader: template_props.CustomBlockImagesLoader,
            StandardBlockImagesLoader: template_props.StandardBlockImagesLoader,
            StandardBlock_To_Widget: template_props.StandardBlock_To_Widget,
            errorPage: template_props.errorPage(global_state),
            loadingPage: template_props.loadingPage
          }, global_state)({
            blocks: global_state.page.blocks,
            images: global_state.page.images,
            custom_page_data: global_state.page.custom_page_data,
            page: global_state.page.page
          } as TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>).map<Action<PublicSiteState>>(a => s3 => {
            return { ...s3, page: { ...s3.page, ...a(s3.page) } };
          }).run(a => {
            setState(res1 => {
              let state1 = a({ ...global_state, page: res1.state.page })
              return { ...res1, state: state1 }
            })
          })}
        </>
      )
    })
  ])